import { exists } from '@/api'

export interface ReferenceUpdateBibliographyRequest {
  bibliographyRealId: number
  memo: string
}

export function ReferenceUpdateBibliographyFromJSON(
  json: any
): ReferenceUpdateBibliographyRequest {
  return ReferenceUpdateBibliographyJSONTyped(json)
}

export function ReferenceUpdateBibliographyJSONTyped(
  json: any
): ReferenceUpdateBibliographyRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    memo: exists(json, 'memo') ? json.memo : ''
  }
}

export function ReferenceUpdateBibliographyToJSON(
  value?: ReferenceUpdateBibliographyRequest | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    bibliography_real_id: value.bibliographyRealId,
    memo: value.memo
  }
}
